import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ConfigAssetLoaderService,
  InterceptorSkipHeader,
  OperationResult,
} from '@icullen/api/shared';
import { withCache } from '@ngneat/cashew';
import { Observable } from 'rxjs';
import { AccountActivationOperationResult } from '../model/account-activate-operation-result.model';
import { AccountDetails } from '../model/account-details.model';
import { Countries } from '../model/countries';

@Injectable({
  providedIn: 'root',
})
export class SelfregisterApiService {
  USER_SELF_REGISTER_API_BASE_URL: string;

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigAssetLoaderService
  ) {
    this.USER_SELF_REGISTER_API_BASE_URL =
      configService.getConfig().apiBaseUrl + 'selfRegister/';
  }

  getCountries(): Observable<Countries> {
    return this.httpClient.get<Countries>(
      this.USER_SELF_REGISTER_API_BASE_URL + 'countries',
      { ...InterceptorSkipHeader, context: withCache() }
    );
  }

  validateEmail(email: string): Observable<OperationResult> {
    return this.httpClient.get<OperationResult>(
      this.USER_SELF_REGISTER_API_BASE_URL + 'verifyEmail?email=' + email
    );
  }

  registerAccount(accountDetails: AccountDetails): Observable<OperationResult> {
    return this.httpClient.post<OperationResult>(
      this.USER_SELF_REGISTER_API_BASE_URL,
      accountDetails
    );
  }

  activateAccount(
    activationCode: string | null
  ): Observable<AccountActivationOperationResult> {
    return this.httpClient.get<AccountActivationOperationResult>(
      this.USER_SELF_REGISTER_API_BASE_URL +
        'activateAccount?activationCode=' +
        activationCode
    );
  }
}
